export class Bulto {
   codigoTipoBulto: number;
   tipoBultoId: number;
   cantidadBultos: number;
   marcas: string;
   idContainer: any;
   sello: any;
   emisorSello: any;
   nombreTipoBulto: string;
   localIndex: number;
}
